import { gql } from "@apollo/client";

export const GET_FRAMEWORK_LIST = gql`
  query getFramework {
    getFramework {
      framework_description
      framework_id
      framework_logo
      framework_name
      is_active
      key
      minimum_evidence_window_size
      maximum_evidence_window_size
    }
  }
`;

export const GET_FRAMEWORK_DETAIL_BY_ID = gql`
  query getFrameworkDetailByFrameworkId(
    $framework_id: Int!
    $end_time: DateTime
  ) {
    getFrameworkDetailByFrameworkId(
      framework_id: $framework_id
      end_time: $end_time
    ) {
      frameworkId
      frameworkName
      frameworkDescription
      frameworkLogo
      launchstatus
      standard
      category
      is_active
      areaDetails {
        area_id
        area_name
        criterias {
          criteria_id
          criteria
          criteria_description
          controls {
            controlsId
            controlsName
            controlsDescription
            controlsTitle
            controlsDomain
            policies {
              policyId
              policyName
              policyFileName
              policyDescription
              policyDisplayName
              isActive
              category
            }
            checks {
              activeCheckId
              activeCheckName
              activeCheckDescription
              activeCheckCategory
              checkStatus
              checkStatusReason
            }
          }
        }
      }
    }
  }
`;

export const GET_CONTROL_DETAIL_BY_ID = gql`
  query getControlsDetailByControlId($controls_id: Int!) {
    getControlsDetailByControlId(controls_id: $controls_id) {
      controlsId
      controlsName
      mappedFrameworkAndCriteria {
        frameworkId
        frameworkName
        frameworkLogo
        launchstatus
        category
        standard
        criterias
      }
      policyDetails {
        policyId
        policyName
      }
      checkDetails {
        activeCheckId
        activeCheckName
        activeCheckDescription
      }
      fileDetails {
        fileId
        maskName
        path
        isFileValid
        fileRejectReason
      }
    }
  }
`;

export const GET_CONTROLS_WITH_CHECKS = gql`
  query getControlsWithChecks {
    getControlsWithChecks {
      success
      message
      data {
        controlsId
        controlsName
        controlsDescription
        controlsDomain
        controlsTitle
        checks {
          activeCheckId
          activeCheckName
          activeCheckDescription
          activeCheckCategory
          checkType
          monitorType
        }
      }
    }
  }
`;

export const CREATE_COMMON_EXCEPTION = gql`
  mutation createCommonException(
    $active_check_id: Int!
    $scope: String
    $reason: String
    $exception_valid_till: String
    $entity_id: String
    $entity_type: String
    $resources: [CommonExceptionResourceItemInput!]
  ) {
    createCommonException(
      active_check_id: $active_check_id
      scope: $scope
      reason: $reason
      exception_valid_till: $exception_valid_till
      entity_id: $entity_id
      entity_type: $entity_type
      resources: $resources
    ) {
      success
      message
      data {
        id
        active_check_id
        scope
        resource_id
        reason
        exception_valid_till
        rego_valid_from
        rego_valid_till
        created_at
        file_id
        entity_id
        entity_type
      }
      totalCreated
    }
  }
`;

export const DELETE_COMMON_EXCEPTION = gql`
  mutation deleteCommonException($ids: [Int!]!) {
    deleteCommonException(ids: $ids) {
      success
      message
    }
  }
`;

export const GET_COMMON_EXCEPTIONS = gql`
  query getCommonExceptions(
    $filters: CommonExceptionFilterInput
    $audit_id: String
    $page: Int
    $limit: Int
  ) {
    getCommonExceptions(
      filters: $filters
      audit_id: $audit_id
      page: $page
      limit: $limit
    ) {
      success
      message
      data {
        id
        active_check_id
        scope
        resource_id
        reason
        exception_valid_till
        rego_valid_from
        rego_valid_till
        created_at
        is_active
        file_id
        entity_id
        entity_type
      }
      totalCount
      currentPage
      totalPages
    }
  }
`;

export const GET_CHECK_DETAILS_BY_ID = gql`
  query getCheckDetailsById($active_check_id: Int!) {
    getCheckDetailsById(active_check_id: $active_check_id) {
      active_check_id
      active_check_name
      active_check_description
      active_check_category
      active_check_type
      monitor_type
      status
      status_reason
      employee_results {
        id
        resource_id
        resource_name
        status
        reason
      }
      resources {
        id
        resource_id
        resource_name
        resource_type
        status
        status_reason
        metadata
        created_at
        updated_at
      }
    }
  }
`;

export const GET_CHECK_DETAILS_BY_TYPE = gql`
  query getCheckDetailsByType(
    $check_type: String!
    $audit_id: String
    $end_time: DateTime
  ) {
    getCheckDetailsByType(
      check_type: $check_type
      audit_id: $audit_id
      end_time: $end_time
    ) {
      active_check_id
      active_check_name
      active_check_description
      active_check_category
      active_check_type
      monitor_type
      status
      status_reason
      remediation_steps
      employee_results {
        id
        resource_id
        resource_name
        status
        reason
      }
      resources {
        id
        resource_id
        resource_name
        resource_type
        status
        status_reason
        metadata
        created_at
        updated_at
      }
    }
  }
`;

export const GET_FILE_BY_FILE_ID = gql`
  query getFileByFileId($file_id: Int!) {
    getFileByFileId(file_id: $file_id) {
      fileId
      maskName
      path
      isFileValid
      fileRejectReason
    }
  }
`;

export const GET_CHECK_FILE_DETAILS = gql`
  query getCheckFileDetails($check_id: Int!) {
    getCheckFileDetails(check_id: $check_id) {
      fileId
      maskName
      path
      isFileValid
      fileRejectReason
    }
  }
`;

export const GET_EVIDENCE_BY_CHECK_ID = gql`
  query GetEvidenceByCheckId($check_id: Int!, $audit_id: String, $is_valid: Boolean) {
    getEvidenceByCheckId(check_id: $check_id, audit_id: $audit_id, is_valid: $is_valid) {
      entityId
      entityType
      entityName
      path
      reason
      fileId
      maskName
      isFileValid
      fileRejectReason
      attachments {
        id
        name
        downloadUrl
      }
    }
  }
`;

export const GET_ALL_EXCEPTIONS = gql`
  query getAllExceptions {
    getAllExceptions {
      check_id
      reason
      file_id
      scope
      account_id
      resource_id
    }
  }
`;

export const TRIGGER_CHECK_RUN = gql`
  mutation TriggerCheckRun($check_id: Int!) {
    triggerCheckRun(check_id: $check_id) {
      success
      message
      taskId
      messageId
    }
  }
`;

export const UPDATE_CONTROL_OWNER_BULK = gql`
  mutation UpdateControlDetailsBulk(
    $controls_ids: [Int!]!
    $control_owner_id: String
  ) {
    updateControlDetailsBulk(
      controls_ids: $controls_ids
      control_owner_id: $control_owner_id
    ) {
      success
      message
      updated
      failed
      results {
        success
        message
        controlsId
      }
    }
  }
`;
